/*
  HALO Carrossel: navegação da faixa horizontal de cards (seção HALO Carrossel).
  A rolagem é nativa (dedo, trackpad, teclado). O JavaScript liga as setas, a barra de
  progresso (a largura mostra quanto cabe na tela e a posição, quanto já foi percorrido) e o
  arraste com o mouse no computador: ao soltar, a faixa segue com um pouco de embalo e encaixa
  no card mais próximo. Um arraste não conta como clique nos cards com link.
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('halo-carrossel')) return;

  class HaloCarrossel extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      this.scroller = this.querySelector('[data-carrossel-scroller]');
      this.prev = this.querySelector('[data-carrossel-prev]');
      this.next = this.querySelector('[data-carrossel-next]');
      this.thumb = this.querySelector('[data-carrossel-thumb]');
      if (!this.scroller) return;

      this.raf = 0;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var self = this;
      this.onScroll = function () {
        if (!self.raf) self.raf = requestAnimationFrame(self.update.bind(self));
      };
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

      this.ro = new ResizeObserver(this.onScroll);
      this.ro.observe(this.scroller);

      if (this.prev) {
        this.onPrev = function () {
          self.go(-1);
        };
        this.prev.addEventListener('click', this.onPrev);
      }
      if (this.next) {
        this.onNext = function () {
          self.go(1);
        };
        this.next.addEventListener('click', this.onNext);
      }

      // Editor de temas: ao selecionar um card, ele vem para a vista.
      this.onBlockSelect = function (e) {
        if (!self.contains(e.target)) return;
        self.scrollToCard(e.target);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.setupDrag();
      this.update();
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.ro) this.ro.disconnect();
      this.scroller.removeEventListener('scroll', this.onScroll);
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.dragAbort) this.dragAbort.abort();
      clearTimeout(this.snapTimer);
    }

    // Arrastar com o mouse. Toque e trackpad continuam com a rolagem nativa.
    setupDrag() {
      var self = this;
      var s = this.scroller;
      var drag = null;
      this.dragAbort = new AbortController();
      var on = { signal: this.dragAbort.signal };

      s.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (s.scrollWidth - s.clientWidth <= 2) return;
        clearTimeout(self.snapTimer);
        drag = { x: e.clientX, left: s.scrollLeft, lastX: e.clientX, lastT: e.timeStamp, v: 0, moved: false, id: e.pointerId };
      }, on);

      s.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved) {
          if (Math.abs(dx) < 4) return;
          drag.moved = true;
          try {
            s.setPointerCapture(e.pointerId);
          } catch (err) {}
          self.classList.add('is-dragging');
        }
        var dt = e.timeStamp - drag.lastT;
        if (dt >= 4) drag.v = (e.clientX - drag.lastX) / dt;
        drag.lastX = e.clientX;
        drag.lastT = e.timeStamp;
        s.scrollLeft = drag.left - dx;
      }, on);

      var end = function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var moved = drag.moved;
        // Mouse parado antes de soltar: sem embalo. Velocidade limitada a 3 px/ms.
        var velocity = e.timeStamp - drag.lastT > 100 ? 0 : Math.max(-3, Math.min(3, drag.v));
        drag = null;
        if (!moved) return;
        self.suppressClick = true;
        setTimeout(function () {
          self.suppressClick = false;
        }, 80);
        // Embalo proporcional à velocidade e encaixe no card mais próximo.
        var step = self.step();
        var max = s.scrollWidth - s.clientWidth;
        var projected = s.scrollLeft - velocity * 220;
        var target = Math.max(0, Math.min(max, Math.round(projected / step) * step));
        s.scrollTo({ left: target, behavior: self.reduce ? 'auto' : 'smooth' });
        clearTimeout(self.snapTimer);
        self.snapTimer = setTimeout(function () {
          self.classList.remove('is-dragging');
        }, self.reduce ? 0 : 550);
      };
      s.addEventListener('pointerup', end, on);
      s.addEventListener('pointercancel', end, on);

      // Depois de arrastar, o clique que o navegador dispara ao soltar não abre o link do card.
      s.addEventListener('click', function (e) {
        if (!self.suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
      }, { capture: true, signal: this.dragAbort.signal });
      s.addEventListener('dragstart', function (e) {
        e.preventDefault();
      }, on);
    }

    // Distância entre o início de um card e o do seguinte (largura do card + espaço).
    step() {
      var cards = this.scroller.querySelectorAll('[data-carrossel-card]');
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      return this.scroller.clientWidth * 0.8;
    }

    go(direction) {
      var button = direction < 0 ? this.prev : this.next;
      if (button && button.getAttribute('aria-disabled') === 'true') return;
      this.scroller.scrollBy({
        left: direction * this.step(),
        behavior: this.reduce ? 'auto' : 'smooth',
      });
    }

    scrollToCard(card) {
      var first = this.scroller.querySelector('[data-carrossel-card]');
      if (!first) return;
      this.scroller.scrollTo({
        left: card.offsetLeft - first.offsetLeft,
        behavior: this.reduce ? 'auto' : 'smooth',
      });
    }

    update() {
      this.raf = 0;
      var s = this.scroller;
      var max = s.scrollWidth - s.clientWidth;
      var overflow = max > 2;
      this.classList.toggle('has-overflow', overflow);
      if (!overflow) return;

      var progress = Math.min(1, Math.max(0, s.scrollLeft / max));
      var visible = Math.max(0.15, Math.min(1, s.clientWidth / s.scrollWidth));
      if (this.thumb) {
        this.style.setProperty('--hc-thumb-w', (visible * 100).toFixed(2) + '%');
        // O deslocamento é em % da própria barra: anda (1 - visible) / visible larguras dela.
        this.style.setProperty('--hc-thumb-x', ((progress * (1 - visible)) / visible * 100).toFixed(2) + '%');
      }
      this.setDisabled(this.prev, progress <= 0.005);
      this.setDisabled(this.next, progress >= 0.995);
    }

    // aria-disabled em vez de disabled: o botão continua com o foco do teclado quando chega ao fim.
    setDisabled(button, disabled) {
      if (!button) return;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
  }

  customElements.define('halo-carrossel', HaloCarrossel);
})();
